import Tooltip from 'components/Tooltip/Tooltip';
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { AiFillDelete } from 'react-icons/ai';
import { FaEdit } from 'react-icons/fa';
import { MdAddCircle } from 'react-icons/md';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import fetchData from 'utils/fetchData';
import stringUtilities from 'utils/stringUtilities';

export default function JobPositionBatches() {
    const [rows, setRows] = useState([]);
    const MySwal = withReactContent(Swal);

    useEffect(() => {
        var pDummyData = [];
        for (var pIndex = 0; pIndex <= 20 - 1; pIndex++)
            pDummyData.push({
                index: pIndex
            });

        var pHeader = document.getElementsByTagName('header');
        if (pHeader.length == 0)
            return;
        pHeader = pHeader[0].parentElement;
        const pObserver = new ResizeObserver(([vEntry]) => {
            if (!vEntry)
                return;
            ;
            document.documentElement.style.setProperty("--header-height", vEntry.target.clientHeight + 'px');
            console.log(vEntry.contentRect);
        });
        pObserver.observe(pHeader);

        LoadData();
        return () => pObserver.disconnect();
    }, []);

    async function LoadData() {
        try {
            var pResponse = await fetchData.Post('/api/JobPositionBatches/Get', {});
            setRows(pResponse.rows);
        } catch (e) {
            toast.error(e);
        }
    }

    const handleDeleteMultiple = async () => {
        var pCheckedIDs = getCheckedIDs();
        if (pCheckedIDs.length == 0) {
            MySwal.fire({
                title: "Error",
                text: 'Please select at 1 row to delete.',
                icon: "warning"
            });
            return;
        }
        var pResult = await MySwal.fire({
            title: "Are you sure?",
            text: "Delete Selected Batches",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
          });
          if (!pResult.isConfirmed)
            return;

          var pToast = toast.loading('Deleting records...');
          try {
            var pResponse = await fetchData.Post('/api/JobPositionBatches/delete', pCheckedIDs);
            LoadData();
          } catch (e) {
            toast.error(e);
          } finally {
            toast.dismiss(pToast);
          }
    };

    function toogleCheck(vID) {
        setRows(prevState =>
            prevState.map(row => {
                if (row.id == vID) {
                    row.selected = !row.selected;
                }
                return row;
            })
        );
    }

    function getCheckedIDs() {
        var pOut = [];
        rows.map(row => {
            if (row.selected)
                pOut.push(row.id);
        });
        return pOut;
    }

    return (
        <div>
            <div className="flex items-center gap-x-4">
                <a href="/#/job-position-batch"
                >
                    <Tooltip text="New Job Position Batch">
                        <MdAddCircle className="text-primary w-6 h-6" />
                    </Tooltip>
                </a>

                <button
                    onClick={() => handleDeleteMultiple()}
                >
                    <Tooltip text="Delete Job Position Batches">
                        <AiFillDelete className="text-red-600 w-6 h-6" />
                    </Tooltip>
                </button>{" "}
            </div>

            <div className="datagrid" style={{ maxHeight: "calc(100vh - 120px)" }}>
                <table>
                    <thead>
                        <tr>
                            <th>
                                <input
                                    type="checkbox"
                                    name="checkbox"
                                />
                            </th>
                            <th>Batch No.</th>
                            <th>Batch Date</th>
                            <th>Recepient</th>
                            <th>Recepient Title</th>
                            <th>Date From</th>
                            <th>Date To</th>
                            <th>Prepared By</th>
                            <th>Prepared By Title</th>
                            <th>Attested By</th>
                            <th>Attested By Title</th>
                            <th className="sticky right-0">Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        {rows.map(row => {
                            return <tr>
                                <td className="text-center">
                                    <input
                                        type="checkbox"
                                        name="checkbox"
                                        checked={stringUtilities.CBool(row.selected)}
                                        onChange={x => toogleCheck(row.id)}
                                    />
                                </td>
                                <td>{row.num}</td>
                                <td>{stringUtilities.FormatDate(row.batchDate)}</td>
                                <td>{row.recepientName}</td>
                                <td>{row.recepientTitle}</td>
                                <td>{stringUtilities.FormatDate(row.dateFrom)}</td>
                                <td>{stringUtilities.FormatDate(row.dateTo)}</td>
                                <td>{row.preparedByName}</td>
                                <td>{row.preparedByTitle}</td>
                                <td>{row.attestedByName}</td>
                                <td>{row.attestedByTitle}</td>
                                <td className="sticky right-0 bg-white text-center">
                                    <Tooltip text="Edit">
                                        <a href={'/#/job-position-batch/' + row.id}
                                            class="btn-edit text-white py-1 px-2 block"
                                        >
                                            <FaEdit className="" />
                                        </a>
                                    </Tooltip>
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}
